import React from 'react'
import { Slide } from '.'

export function SlidesCarousel({ listSliders }) {
  return (
    <div className='slider'>
      <div className='slider__container'>
        <div className='slider__wrapper'>
          <div className='slider__items flex-align-center-min-1024'>
            {listSliders.map((s, i) => <Slide s={s} key={i} />)}
          </div>
        </div>
      </div>
      <a href='#' className='slider__control' data-slide='prev'></a>
      <a href='#' className='slider__control' data-slide='next'></a>
    </div>
  )
}


// WEBPACK FOOTER //
// ./src/components/snippets/ChiefSliderComponent/shared/core/impl/ui/SlidesCarousel.jsx